<template lang="pug">
div 
    div(ref="code" style="height: calc(100vh - 0px); width: calc(100% - 0px);overflow: hidden;")
    
</template>

<script>
import axios from 'axios';
// import * as monaco from 'monaco-editor';
const host = '/api/fs';

export default {
    props: ['name', 'id', 'language'],
    data() {
        this.header = {
            headers: {
                'x-jwt': this.$api.jwt,
            }
        };
        
        return {
            visible: false,
            previewContent: null,
            editor: null,
        }
    },
    mounted() {
        this.load();
    },
    unmounted() {
        
    },
    methods: {
        handleClose() {
            this.editor?.dispose();
        },
        async load() {
            const monaco = await import('monaco-editor');
            this.visible = true;
            axios.get(`${host}/download/${this.id}`, {
                ...this.header,
                responseType: 'blob',
            }).then(res => {
                res.data.text().then(text => {

                   this.$nextTick(() => {
                        this.editor = monaco.editor.create(this.$refs.code, {
                            value: text,
                            language: this.language,
                            // 可添加更多配置，如主题、字体等
                            theme: 'vs-dark',
                            colorDecorators: true, // 颜色装饰器
                            readOnly: true,
                        });
                    });
                });
                // let fileReader = new FileReader();
                // fileReader.readAsArrayBuffer(res.data);
                // fileReader.onload = (e) => {
                //     console.log(e.target.result);
                //     this.previewContent = e.target.result;
                // };
            })
        }
    }
}
</script>
